import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { createRootRoute, createRoute, createRouter, Outlet, RouterProvider, } from "@tanstack/react-router";
import { BaseLayout } from "@app/layouts/BaseLayout";
// Devtools are loaded dynamically in development to avoid type/version drift and prod bundle bloat
const Devtools = import.meta.env.DEV
    ? React.lazy(async () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mod = await import("@tanstack/react-router-devtools");
        const Comp = mod.RouterDevtools ?? mod.TanStackRouterDevtools ?? mod.default ?? (() => null);
        return { default: Comp };
    })
    : () => null;
const RootComponent = () => (_jsxs(BaseLayout, { children: [_jsx(Outlet, {}), _jsx(React.Suspense, { fallback: null, children: _jsx(Devtools, { position: "bottom-right" }) })] }));
const rootRoute = createRootRoute({ component: RootComponent });
const HomePage = React.lazy(() => import("@features/profile/pages/HomePage"));
const LoginPage = React.lazy(() => import("@features/auth/pages/LoginPage"));
const indexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/",
    component: () => (_jsx(React.Suspense, { fallback: _jsx("div", { children: "Loading\u2026" }), children: _jsx(HomePage, {}) })),
});
const loginRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/auth/login",
    component: () => (_jsx(React.Suspense, { fallback: _jsx("div", { children: "Loading\u2026" }), children: _jsx(LoginPage, {}) })),
});
const routeTree = rootRoute.addChildren([indexRoute, loginRoute]);
const router = createRouter({ routeTree });
export const AppRouterProvider = () => _jsx(RouterProvider, { router: router });
